/**
 * Справочник горячих клавиш для показа пользователю.
 *
 * Лежит рядом с обработчиком клавиш (useEditorHotkeys), чтобы список в подсказке
 * не расходился с тем, что реально работает: добавил клавишу — допиши её здесь.
 * Строки на русском, как и весь интерфейс; при локализации уедут в словарь.
 */

export interface HotkeyItem {
	/** Клавиши как их показать пользователю */
	keys: string[];
	action: string;
}

export interface HotkeyGroup {
	title: string;
	items: HotkeyItem[];
}

export const HOTKEY_GROUPS: HotkeyGroup[] = [
	{
		title: "Инструменты",
		items: [
			{ keys: ["V"], action: "Выделение" },
			{ keys: ["N"], action: "Окно" },
			{ keys: ["E"], action: "Объект из каталога" },
			{ keys: ["C"], action: "Кабель: от прибора к распредкоробке" },
			{ keys: ["P"], action: "Труба: от стояка или коллектора к водорозетке" },
			{ keys: ["R"], action: "Повернуть предмет на полу на 90°" },
			{ keys: ["Tab"], action: "Перегородка ⇄ несущая, можно посреди черчения" },
		],
	},
	{
		title: "Черчение",
		items: [
			{ keys: ["Цифры"], action: "Точный ввод длины стены" },
			{ keys: ["Alt"], action: "Свободный режим без привязок" },
			{ keys: ["Esc"], action: "Закончить цепочку, снять выделение" },
			{ keys: ["Delete"], action: "Удалить выделенное" },
			{
				keys: ["Ctrl"],
				action:
					"У выделенного предмета — расстояния до стен; навести на другой — с его стороны до него",
			},
		],
	},
	{
		title: "Проект и вид",
		items: [
			{ keys: ["Ctrl", "Z"], action: "Отменить" },
			{ keys: ["Ctrl", "Shift", "Z"], action: "Повторить" },
			{ keys: ["Ctrl", "S"], action: "Сохранить проект" },
			{ keys: ["Стрелки / WASD"], action: "Панорама 2D / перемещение камеры 3D" },
			{ keys: ["перетаскивание пустого места"], action: "Панорама (инструмент выделения)" },
			{ keys: ["Shift", "перетаскивание"], action: "Панорама любым инструментом" },
			{
				keys: ["Пробел", "перетаскивание"],
				action: "Сдвиг вида любым инструментом, не обрывая черчение",
			},
			{ keys: ["Два пальца по тачпаду"], action: "Сдвиг вида" },
			{ keys: ["Колесо"], action: "Зум" },
			{ keys: ["Щипок на тачпаде"], action: "Плавный зум" },
		],
	},
];
